var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96705 20H21.002V3.00003H3.00195V23.1032L7.96705 20ZM6.49976 11.5C6.49976 12.0523 6.94747 12.5 7.49976 12.5C8.05204 12.5 8.49975 12.0523 8.49975 11.5C8.49975 10.9477 8.05204 10.5 7.49976 10.5C6.94747 10.5 6.49976 10.9477 6.49976 11.5ZM10.9998 11.5C10.9998 12.0523 11.4475 12.5 11.9998 12.5C12.552 12.5 12.9998 12.0523 12.9998 11.5C12.9998 10.9477 12.552 10.5 11.9998 10.5C11.4475 10.5 10.9998 10.9477 10.9998 11.5ZM16.4998 12.5C15.9475 12.5 15.4998 12.0523 15.4998 11.5C15.4998 10.9477 15.9475 10.5 16.4998 10.5C17.052 10.5 17.4998 10.9477 17.4998 11.5C17.4998 12.0523 17.052 12.5 16.4998 12.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenIcon);
export default __webpack_public_path__ + "static/media/open-icon.3745ed1f5f17f8229f988119af02aecd.svg";
export { ForwardRef as ReactComponent };